(function() {
  'use strict';

  function ReportsController(
    $rootScope, Report, Reports, ReportSearch, Profile, List, Security, $translate, Utils, Features
  ) {
    var ctrl = this;

    Utils.setPageTitle('Reports');

    ctrl.$onInit = function() {
      ctrl.options = {
      };

      ctrl.searchModel = Profile.getListPreferences('reports').current;

      var makeDocs = function(item) {
        return new Report(item);
      };

      Features.isEnabled('reporting').then(function(res) {
        ctrl.featureEnabled = res;
      });

      ctrl.list = new List({
        search: ReportSearch.search,
        model: ctrl.searchModel,
        idField: 'id',
        makeDocs: makeDocs,
        searchFn: Reports.searchIds.bind(Reports),
        fetchFn: function(ids) {
          return Reports.fetchIds(ids, { transformType: 'light' });
        },
        defaultFilter: {
          purpose: 'latestDrafts'
        }
      });

      $rootScope.$broadcast('KZCurrentListChange', { list: 'reports', search: ctrl.list.search });
      ctrl.list.doLoadItems();

      ctrl.actions = [
        {
          label: $translate.instant('Add new report'),
          icon: 'icon-edit',
          route: ['/report_templates', 'new'],
          showCondition: Security.hasPermission.bind(this, 'reports.edit'),
          klass: 'btn-success'
        }
      ];
    };
  }

  ReportsController.$inject = [
    '$rootScope',
    'ReportFactory',
    'ReportTemplatesService',
    'ReportTemplateSearch',
    'ProfileService',
    'APIIDListFactory',
    'SecurityService',
    '$translate',
    'UtilsService',
    'FeaturesService'
  ];

  angular.module('component.reports')
    .component('reportTemplatesComponent', {
      controller: ReportsController,
      controllerAs: 'reportsCtrl',
      templateUrl: 'app/components/reports/templates_list.html'
    });
})();
